import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'sonner';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetails from './pages/ClientDetails';
import Projects from './pages/Projects';
import Financials from './pages/Financials';
import Invoices from './pages/Invoices';
import Team from './pages/Team';
import TeamMemberDetails from './pages/TeamMemberDetails';
import ProjectDetails from './pages/ProjectDetails';
import ChangeRequests from './pages/ChangeRequests';
import Analytics from './pages/Analytics';
import Pricing from './pages/Pricing';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';
import './App.css';
import { useAuth } from './contexts/AuthContext';
import { hasFeature } from './utils/featureFlags';

const ProtectedRoute = ({ children, requiredFeature }) => {
  const { user } = useAuth();
  if (user && user.role !== 'admin' && requiredFeature && !hasFeature(user, requiredFeature)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="analytics" element={
          <ProtectedRoute requiredFeature="Analytics">
            <Analytics />
          </ProtectedRoute>
        } />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:clientId" element={<ClientDetails />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:projectId" element={<ProjectDetails />} />
        <Route path="income" element={<Financials />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="team" element={
          <ProtectedRoute requiredFeature="Team">
            <Team />
          </ProtectedRoute>
        } />
        <Route path="team/:memberId" element={
          <ProtectedRoute requiredFeature="Team">
            <TeamMemberDetails />
          </ProtectedRoute>
        } />
        <Route path="change-requests" element={<ChangeRequests />} />
        <Route path="settings" element={<Settings />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="subscription/success" element={<SubscriptionSuccess />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
